var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.042q1 0 1.688-.688.687-.687.687-1.687t-.687-1.688Q21 14.292 20 14.292t-1.688.687q-.687.688-.687 1.688t.687 1.687q.688.688 1.688.688Zm0 15.041q5.333-4.625 8.208-9.271 2.875-4.645 2.875-7.812 0-5.042-3.187-8.229Q24.708 5.583 20 5.583t-7.896 3.188Q8.917 11.958 8.917 17q0 3.167 2.895 7.812 2.896 4.646 8.188 9.271Zm0 1.959q-6.333-5.625-9.417-10.417Q7.5 20.833 7.5 17q0-5.875 3.771-9.354Q15.042 4.167 20 4.167q4.958 0 8.729 3.479Q32.5 11.125 32.5 17q0 3.833-3.083 8.625Q26.333 30.417 20 36.042ZM20 17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.25165847e4e3c5443756028f7ea3887f.svg";
export { ForwardRef as ReactComponent };